import { mapMutations } from 'vuex'

import { createTurnstileCaptcha } from '~/lib/turnstileCaptcha.ts'

export default {
  data () {
    return {
      mix_captchaObj: null,
    }
  },
  methods: {
    async initCaptchaObj () {
      // if captcha already loaded
      if (this.mix_captchaObj) {
        return this.mix_captchaObj
      }

      const captcha = await createTurnstileCaptcha(this.$config.turnstileSiteKey, {
        theme: 'light',
      })

      // wrap the Turnstile controller in the shape AuthFormSubmit.onFormSubmit() expects:
      // onSuccess/onError/onClose/showCaptcha/getValidate/reset
      this.mix_captchaObj = {
        onSuccess (callback) {
          captcha.onSuccess(() => callback())
        },
        onError (callback) {
          captcha.onError(() => callback())
        },
        onClose (_callback) {
          // Turnstile's invisible widget has no user-initiated "close" event to hook into
        },
        showCaptcha () {
          captcha.execute()
        },
        getValidate () {
          const token = captcha.getToken()
          return token ? { turnstile_token: token } : false
        },
        reset () {
          captcha.reset()
        },
      }

      this.setRecaptchaReference(this.mix_captchaObj)

      return this.mix_captchaObj
    },

    async startCaptcha () {
      // load captcha if not loaded
      const captchaObj = await this.initCaptchaObj()

      // add event hooks and verify
      return new Promise((resolve, reject) => {
        captchaObj.onSuccess(() => resolve(captchaObj))
        captchaObj.onError(() => reject(captchaObj))
        captchaObj.onClose(() => reject(captchaObj))
        captchaObj.showCaptcha()
      })
    },
    ...mapMutations({
      setRecaptchaReference: 'profile/auth/setRecaptchaReference',
    }),
  },
}
